import InfoCard from "../../Layout/DesignSystem/InfoCard/InfoCard";
import Formatter from "../../Data/Domain/Formatter";
import "./DashboardOwner.css";

const DashboardOwnerCards = ({ cards,  isLoading }) => {
  const infoCardsData = [
    {
      key: 1,
      value: Formatter.formatNumber(cards.total_per_unit || 0.0),
      title: `Total per Unit`,
      unit: "ton CO₂e/ha",
      type: "blue-card",
    },
    {
      key: 2,
      value: Formatter.formatNumber(cards.total_removal || 0.0),
      title: `Total Removal`,
      unit: "ton CO₂",
      type: "dark-green-card",
    },
    {
      key: 3,
      value: cards.removalavoidance,
      title: "Removal/Avoidance",
      type: "dark-degraded-card",
    },
    {
      key: 4,
      value: cards.type,
      title: "Type",
      type: "green-card",
      valueVariant: "longText",
    },
  ];

  return (
    <div className="info-card-container">
      {infoCardsData.map(({ key, ...statistic }) => (
        <div key={key} className="info-card-wrapper">
          <InfoCard statistic={statistic} isLoading={isLoading} />
        </div>
      ))}
    </div>
  );
};

export default DashboardOwnerCards;
